import React from 'react';
import { Info } from 'lucide-react';
import './FieldHint.css';

interface FieldHintProps {
  /** Plain-language explanation shown in a tooltip bubble on hover/focus. */
  text: string;
}

/**
 * Small info icon placed next to a field label for genuinely confusing fields
 * (zero-pre-training UX, Tier 1). Keyboard accessible: focusable, tooltip
 * shows on focus as well as hover.
 */
const FieldHint: React.FC<FieldHintProps> = ({ text }) => (
  <span className="ims-field-hint" tabIndex={0} role="note" aria-label={text}>
    <Info size={13} />
    <span className="ims-field-hint-bubble">{text}</span>
  </span>
);

export default FieldHint;
